import { useMediaQuery } from "@mui/material";
import TextAvatar from "components/avatar/TextAvatar";
import UIButton from "components/ui/form/UIButton";
import UISelect from "components/ui/select/UISelect";
import { TELEHEALTH_MEETING_LINK } from "config/constants/constants";
import { formatDateWithOrdinalSuffix, getDurationString } from "config/helpers/date_helper";
import { getOffsetForLocation, getTimeZoneAbbreviation } from "config/helpers/timezone_helper";
import dayjs from "dayjs";
import React, { useEffect, useState, useTransition } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Details = ({ bookingDetails, setOpen, locationObj }) => {

  const i18n = useTranslation()
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const isMediumScreen = useMediaQuery(
    "(min-width: 768px) and (max-width: 992px)"
  );

  const [telehealthDetails, setTelehealthDetails] = useState();
  const Navigate = useNavigate();
  const loading = useSelector((state) => state.app.loader);
  const isDark = useSelector((state) => state?.app?.theme) === "dark";
  const titleBgColor = `bg-title`;
  const [countdown, setCountdown] = useState();
  
 const [convertedTime , setConvertedTime] = useState({})

  useEffect(() => {
    let interval;

    if (bookingDetails?.isTelehealth && bookingDetails?.extension) {
      const telehealthData = bookingDetails?.extension?.filter(f => f?.url?.includes('meeting-id'))?.[0];
      const currentDate = dayjs();
      const telehealthDate = bookingDetails?.date;
      const timeDifferenceMinutes = telehealthDate?.diff(currentDate, 'minutes');
      let timeDifferenceSeconds = telehealthDate?.diff(currentDate, 'seconds');

      if (timeDifferenceMinutes <= 60) {
        // let timeDifferenceSeconds = timeDifferenceMinutes*60;
        interval = setInterval(() => {

          if (Math?.floor(timeDifferenceSeconds / 60) === 14) {
            setTelehealthDetails({
              ...telehealthData,
              isBefore10min: true,
            })
          }
          if (timeDifferenceSeconds >= 0) {
            setCountdown(timeDifferenceSeconds);
            Math?.floor()
            timeDifferenceSeconds = timeDifferenceSeconds - 1;
          }
          else {
            // setCountdown();
            // clearInterval(interval);
          }
        }, 1000)
      }

      if (timeDifferenceMinutes <= 10) {
        setTelehealthDetails({
          ...telehealthData,
          isBefore10min: true,
        })
      } else {
        setTelehealthDetails(telehealthData);
      }

      // const endTime = dayjs(bookingDetails?.endTime);
      // const startTime = dayjs(bookingDetails?.startTime);

      // const isWithinRange = currentDate.isBetween(startTime, endTime);

      if (dayjs()?.isAfter(bookingDetails?.endTime)) {
        setTelehealthDetails({
          ...telehealthDetails,
          isBefore10min: false,
        })
      }
    }
    return () => clearInterval(interval);
  }, [bookingDetails])

  const joinTelehealthMeeting = () => {
    const meetingLink = `${window.location.origin}${TELEHEALTH_MEETING_LINK}/${bookingDetails?.id}`;
    window.open(meetingLink, '_blank');
  }


  const convertTimeWithOffset = async (startTime, endTime) => {
    const offset = getOffsetForLocation(locationObj?.resource?.address?.state);
    const startMoment = dayjs(startTime).add(offset, 'minutes');
    const endMoment = dayjs(endTime).add(offset, 'minutes');

    const convertedStartTime = startMoment;
    const convertedEndTime = endMoment;

    return { convertedStartTime, convertedEndTime };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await convertTimeWithOffset(bookingDetails?.startTime,bookingDetails?.endTime);
        setConvertedTime(res);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };

    if(locationObj){
      fetchData();
    }

  }, [locationObj]);



  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-lg-6 col-md-12">
          <div className="card mb-4 shadow-sm rounded">
            <div className="card-body p-3">
              <div
                className={`icon icon-size icon-32 position-absolute top-20px start-10px ${bookingDetails?.isTelehealth === true
                    ? "icon-video"
                    : "icon-walk-in"
                  }`}
                style={{
                  top: '10px',
                  left: '10px',
                }}
              ></div>

              <div className="row">
                <div
                  className={`col-lg-6 col-md-6 d-flex flex-column justify-content-center align-items-center ${!isSmallScreen && "border-right"
                    } ${isSmallScreen && "border-bottom"}`}
                >
                  <TextAvatar
                    text={bookingDetails?.practitioner?.label}
                    circle
                    height={isSmallScreen ? "80px" : "120px"}
                    width={isSmallScreen ? "80px" : "120px"}
                    sx={{ fontSize: "40px" }}
                  />
                  <div className="text-center mt-3">
                    <div className="font-medium b-500">
                      {bookingDetails?.practitioner?.label}
                      {/* <div className="fxs text">{bookingDetails?.specialty}</div> */}{" "}
                    </div>
                    <div className="text-center mt-3">
                      {
                        !countdown &&
                        !telehealthDetails?.isBefore10min &&
                        bookingDetails?.status !== 'cancelled' && bookingDetails?.status !== 'fulfilled' && (
                          <>
                            <div class="icon icon-20 icon-size me-2 icon-vector-video "></div>
                            <div>
                              {
                                getDurationString(bookingDetails?.startTime)
                              }
                            </div>
                            {/* {
                              bookingDetails?.hoursLeft ?
                                <div>
                                  {
                                    showHours(bookingDetails?.hoursLeft)
                                  }
                                </div>
                                :
                                <div>
                                  {
                                    showDays(bookingDetails?.daysLeft)
                                  }
                                </div>

                            } */}
                          </>
                        )
                      }
                      {
                        countdown >= 0 && (
                          <>
                            <div>Time Left</div>
                            <div>
                              {Math?.floor(countdown / 60)} : {(countdown % 60) < 10 ? '0' : ''}{countdown % 60}
                            </div>
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="border-bottom py-3 px-4">
                    <table className="w-100">
                      <tbody>
                      <tr className="mb-1">
                      <th className=" align-top pe-2">{i18n.t('appointments.NAME')}</th>
                      <td className="align-top">
                         <div className="d-flex align-items-start">
                         <div className="pe-2">:</div>
                         <div>{bookingDetails?.patient?.label}</div>
                         </div>
                      </td>
                      </tr>

                        {/* <tr className="mb-1">
                          <th>Age</th>
                          <th>:</th>
                          <td>23</td>
                        </tr> */}
                        <tr className="mb-1">
                          <th className=" align-top pe-2">{i18n.t('appointments.DATE')}</th>
                          <td className="align-top">
                          <div className="d-flex align-items-start">
                         <div className="pe-2">:</div>
                          <div>
                            {formatDateWithOrdinalSuffix(
                              bookingDetails?.startTime
                            )}
                            </div>
                            </div>
                          </td>
                        </tr>
                        <tr className="mb-1">
                          <th className=" align-top pe-2">Practice Time</th>
                          <td className="align-top">
                          <div className="d-flex align-items-start">
                         <div className="pe-2">:</div>
                         <div>
 {/* <div>{formatDateWithOrdinalSuffix(bookingDetails?.startTime)}</div> */}
 <div
                              className={` rounded ${isDark && "text-dark"
                                } ${titleBgColor}`}
                            >
                              {dayjs(convertedTime?.convertedStartTime)?.format("dddd")}
                            </div>
                            <div>
                              {dayjs(convertedTime?.convertedStartTime)?.format('hh:mm A')} {}
                              - {}
                              {dayjs(convertedTime?.convertedEndTime)?.format('hh:mm A')} {} 
                              {getTimeZoneAbbreviation(locationObj?.resource?.address?.state)}
                            </div>
                            </div>
                            </div>
                           
                          </td>
                        </tr>
                        <tr className="mb-1">
                          <th className=" align-top pe-2">My Time</th>
                          <td className="align-top">
                          <div className="d-flex align-items-start">
                         <div className="pe-2">:</div>
                         <div>
 {/* <div>{formatDateWithOrdinalSuffix(bookingDetails?.startTime)}</div> */}
 <div
                              className={` rounded ${isDark && "text-dark"
                                } ${titleBgColor}`}
                            >
                              {dayjs(bookingDetails?.startTime)?.format("dddd")}
                            </div>
                            <div>
                              {dayjs(bookingDetails?.startTime)?.format(
                                "hh:mm A"
                              )}{" "}
                              -{" "}
                              {dayjs(bookingDetails?.endTime)?.format(
                                "hh:mm A"
                              )} {getTimeZoneAbbreviation()}
                            </div>
                            </div>
                            </div>
                           
                          </td>
                        </tr>
                        <tr className="mb-1">
                          <th className=" align-top pe-2">{i18n.t('appointments.TYPE')}</th>
                          <td className="align-top">
                          <div className="d-flex align-items-start">
                         <div className="pe-2">:</div>
                          <div>{bookingDetails?.appointmentType?.display}</div>
                          </div>
                          </td>
                        </tr>
                        <tr className="mb-1">
                          <th className=" align-top pe-2">{i18n.t('appointments.LOCATION')}</th>
                          <td className="align-top">
                          <div className="d-flex align-items-start">
                         <div className="pe-2">:</div>
                          <div>{bookingDetails?.location.label}</div>
                          </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="p-3">
                    {bookingDetails?.isTelehealth === true ? (
                      <UIButton
                        fullWidth
                        sx={{ marginBottom: "10px", fontSize: "12px" }}
                        text= {i18n.t('appointments.JOIN_MEETING')}
                        disabled={bookingDetails?.status === 'cancelled' || bookingDetails?.status == 'fulfilled' || !telehealthDetails?.isBefore10min}
                        callback={joinTelehealthMeeting}
                      />
                    ) : (
                      <div class="walk-in-consultation p-1 mb-1 rounded-pill p-2 mb-2 ">
                        {i18n.t('appointments.WALK_IN_CONSULTATION')}
                      </div>
                    )}

                    <div className="row g-2">
                      <div className="col-12 col-md-5">
                        <UIButton
                          fullWidth
                          text={i18n.t('appointments.RESCHEDULE')}
                          className="fs-md-12 fs-10 fs-lg-1"
                          disabled={bookingDetails?.status === 'cancelled' || bookingDetails?.status == 'fulfilled' || dayjs()?.isAfter(bookingDetails?.startTime)}
                          callback={() => {
                            Navigate("/appointments/schedule?tabs=no", {
                              state: {
                                bookingDetails: bookingDetails,
                              },
                            });
                          }}
                          sx={{ fontSize: "10px" }}
                        />
                      </div>
                      <div className="col-12 col-md-7">
                        <UIButton
                          disabled={bookingDetails?.status === "cancelled" || bookingDetails?.status == 'fulfilled' || dayjs()?.isAfter(bookingDetails?.startTime)}
                          className="fs-md-12 fs-10 fs-lg-1"
                          fullWidth
                          backgroundColor="line_red"
                          variant="outlined"
                          text={i18n.t('appointments.CANCEL_APPOINTMENT')}
                          callback={() => {
                            setOpen(true);
                          }}
                          sx={{ fontSize: "10px" }}
                          loading={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            bookingDetails?.status !== 'cancelled' && bookingDetails?.status !== 'fulfilled' &&
            // bookingDetails?.hoursLeft >= 0 &&
            !dayjs()?.isAfter(bookingDetails?.endTime) &&

            bookingDetails?.isTelehealth &&
            (!countdown ||
              !telehealthDetails?.isBefore10min) &&
            countdown !== 0 &&
            <div className="b-500 mb-3 fst-italic"> {i18n.t('appointments.JOIN_MEETING_NOTE')}</div>
          }
        </div>
        {bookingDetails?.status !== 'cancelled' &&
          <div className="col-lg-6 col-md-12">
            <div className="mb-4 fw-bold fs">
              {i18n.t('appointments.TASKS_TO_DO_BEFORE_YOUR_CONSULTATION')}
            </div>
            <div className="mb-4" style={{ fontSize: "12px" }}>
              <ol>
                <li>
                 {i18n.t('appointments.LINE_1')}
                </li>
                <li>
                {i18n.t('appointments.LINE_2')}
                </li>
                <li>
                {i18n.t('appointments.LINE_3')}
                </li>
                <li>
                {i18n.t('appointments.LINE_4')}
                </li>
              </ol>
            </div>

            <div className="mb-3 fw-bold fs">{i18n.t('appointments.BILLING')}</div>

            {/* Continue Button */}
            <div>
              {/* <UIButton
              fullWidth
              text="You will be billed after the consultation  "
            /> */}
              <div className="billing-text p-2 mb-4 rounded-pill">
                {i18n.t('appointments.YOU_WILL_BE_BILLED_AFTER_THE_CONSULTATION')}

              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default Details;
